module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("此藥盒最大存量: " + _vm._s(_vm.currentDrugInDevice.max_stock))]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("此藥物安全存量: " + _vm._s(_vm.selectedDrugLowAmountLimitData.min_stock))])]), _vm._v(" "), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "checkNum": _vm.currentDrugInDevice.max_stock,
      "valueMoreThanZero": false,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h5', [_vm._v("此藥盒目前數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'next') ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.modalStatus.lowAmount) ? _c('ResetLowAmonutModal', {
    on: {
      "closeModal": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1381b4c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckAmountFlow/ConfirmFlow.vue
// module id = 1395
// module chunks = 1